import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 1,
  class: "flex-grow-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Preloader = _resolveComponent("Preloader")!
  const _component_LeftSidebar = _resolveComponent("LeftSidebar")!
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CreateTaskModal = _resolveComponent("CreateTaskModal")!
  const _component_AddNewLabelModal = _resolveComponent("AddNewLabelModal")!
  const _component_AddNewCardModal = _resolveComponent("AddNewCardModal")!
  const _component_AddNewFileModal = _resolveComponent("AddNewFileModal")!
  const _component_AddNewOrderModal = _resolveComponent("AddNewOrderModal")!
  const _component_AddNewCategorieModal = _resolveComponent("AddNewCategorieModal")!
  const _component_AddNewContactModal = _resolveComponent("AddNewContactModal")!
  const _component_AddNewCustomerModal = _resolveComponent("AddNewCustomerModal")!
  const _component_AddNewLeadModal = _resolveComponent("AddNewLeadModal")!
  const _component_AddNewDealsModal = _resolveComponent("AddNewDealsModal")!
  const _component_AddNewUserModal = _resolveComponent("AddNewUserModal")!
  const _component_AddNewInstructorsModal = _resolveComponent("AddNewInstructorsModal")!
  const _component_SettingsSidebar = _resolveComponent("SettingsSidebar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Preloader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.shouldShowSidebar && !_ctx.isNotFound)
      ? (_openBlock(), _createBlock(_component_LeftSidebar, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["main-content d-flex flex-column", { 'p-0': _ctx.shouldShowPaddingZero || _ctx.isNotFound }])
      }, [
        (_ctx.shouldShowHeader && !_ctx.isNotFound)
          ? (_openBlock(), _createBlock(_component_TopHeader, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view),
        (_ctx.shouldShowDiv && !_ctx.isNotFound)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.shouldShowFooter && !_ctx.isNotFound)
          ? (_openBlock(), _createBlock(_component_MainFooter, { key: 2 }))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_CreateTaskModal),
    _createVNode(_component_AddNewLabelModal),
    _createVNode(_component_AddNewCardModal),
    _createVNode(_component_AddNewFileModal),
    _createVNode(_component_AddNewOrderModal),
    _createVNode(_component_AddNewCategorieModal),
    _createVNode(_component_AddNewContactModal),
    _createVNode(_component_AddNewCustomerModal),
    _createVNode(_component_AddNewLeadModal),
    _createVNode(_component_AddNewDealsModal),
    _createVNode(_component_AddNewUserModal),
    _createVNode(_component_AddNewInstructorsModal),
    _createVNode(_component_SettingsSidebar)
  ]))
}